import LeafSpinner from "./LeafSpinner";
import Container from "react-bootstrap/Container";

export default function LoadingPage() {
    return (
        <Container fluid className="position-fixed h-100 w-100 d-flex justify-content-center align-items-center">
            <LeafSpinner />
        </Container>
    );
}